import React from 'react'
import { Container, BoxCol4, BoxCol6, ImagemPrincipal, TextoBanner, BoxEconomize, BoxEconomizeTexto, BoxAssinaturas, ItemAssinatura, ItemAssinaturaTag, ItemAssinaturaTitulo, ItemAssinaturaPrecoDe, ItemAssinaturaPrecoPor, ItemAssinaturaLinkCartao, ItemAssinaturaLinkAVista, TextoBaixo } from './Styled'
import logoTJSP from 'images/promocao-tj-sp-2025/tjsp.png'
import bgBannerDesktop from 'images/promocao-tj-sp-2025/bg-banner-principal-desktop.jpg'
import { toMoney } from 'utils/helpers'

export default function BannerPrincipal ({ planos, desconto }) {

	return (
		<Container bgDesktop={bgBannerDesktop} id='bannerPromocao'>

			{/* Textos Banner */}
			<BoxCol4 className='boxTextos'>
				<ImagemPrincipal src={logoTJSP} />
				<TextoBanner>Você saiu da inércia, se preparou, evoluiu.<br /> Agora é hora de transformar esse esforço<br /> em resultado.</TextoBanner>
				<TextoBanner>Mais de <strong>73 mil vagas</strong> estão previstas nos próximos meses<br /> e o que você já estudou pode te colocar na frente.</TextoBanner>
				<TextoBanner>Garanta <strong>40% OFF</strong> na Assinatura Premium e acelere sua<br /> aprovação com tudo o que já construiu.</TextoBanner>
			</BoxCol4>

			{/* Aviso Banner */}
			<BoxCol6>
				
				{/* Box Economize */}
				<BoxEconomize>
					<BoxEconomizeTexto><strong>Economize até</strong> {toMoney(desconto)}</BoxEconomizeTexto>
				</BoxEconomize>

				{/* Lista Assinaturas */}
				<BoxAssinaturas>

					{ planos.map((assinatura, indexAssinaturas) => {
						return assinatura.assinaturas.map((item, index) => {

							return (
								<ItemAssinatura key={index}>

									{/* Tag */}
									<ItemAssinaturaTag primeiro={ indexAssinaturas == 0 ? true : false }>{ indexAssinaturas === 0 ? 'A mais vendida' : 'Custo x Benefício' }</ItemAssinaturaTag>

									{/* Título */}
									<ItemAssinaturaTitulo>{item.nome.split(" - ")[0]}</ItemAssinaturaTitulo>

									{/* Preço De */}
									<ItemAssinaturaPrecoDe>{item.cartao.preco_de} por</ItemAssinaturaPrecoDe>

									{/* Preço Por */}
									<ItemAssinaturaPrecoPor>12x <strong>{item.cartao.preco_por.split('12x ')[1]}</strong></ItemAssinaturaPrecoPor>

									{/* Link Cartão */}
									<ItemAssinaturaLinkCartao primeiro={ indexAssinaturas == 0 ? true : false } href={item.cartao.link}>Parcele em 12x sem juros</ItemAssinaturaLinkCartao>

									{/* Link A Vista */}
									<ItemAssinaturaLinkAVista primeiro={ indexAssinaturas == 0 ? true : false } href={item.boleto.link}>Ganhe +10% OFF à vista</ItemAssinaturaLinkAVista>

								</ItemAssinatura>
							)

						})
					})}

				</BoxAssinaturas>

				{/* Texto Baixo */}
				<TextoBaixo>Oferta por tempo limitado, liberada apenas para alunos<br /> selecionados. Aproveite agora!</TextoBaixo>

			</BoxCol6>

		</Container>
	)
	}
